(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6076],{

/***/ 6685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(81333);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/api/routes/growthMasters/queries/index.ts + 2 modules
var queries = __webpack_require__(94650);
// EXTERNAL MODULE: ./src/views/GrowthMasters/components/Layout/Layout.tsx + 5 modules
var Layout = __webpack_require__(63946);
// EXTERNAL MODULE: ./src/views/GrowthMasters/components/WantToLearnMore/WantToLearnMore.tsx
var WantToLearnMore = __webpack_require__(60114);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/Badge/index.ts + 2 modules
var Badge = __webpack_require__(16154);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/withDesignTokens.tsx
var withDesignTokens = __webpack_require__(72300);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../libs/matcha/components/Paper/index.ts + 2 modules
var Paper = __webpack_require__(16164);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/AuthorCard/AuthorCard.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}





var Description = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e3dd55v4"
} : 0)("width:100%;text-align:left;margin-top:4px;transition:color 0.3s ease;color:", function (_ref) {
  var color = _ref.color;
  return color;
}, ";" + ( true ? "" : 0));
var BodyWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e3dd55v3"
} : 0)( true ? "" : 0);
var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Paper/* default */.Z,  true ? {
  target: "e3dd55v2"
} : 0)("display:grid;grid-auto-flow:column;justify-content:start;gap:16px;align-items:center;width:auto;background-color:", function (_ref2) {
  var backgroundColor = _ref2.backgroundColor;
  return backgroundColor;
}, ";color:", function (_ref3) {
  var color = _ref3.color;
  return color;
}, ";", function (_ref4) {
  var variant = _ref4.variant,
      theme = _ref4.theme;
  return variant === "filled" &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)(theme.shadows[2], ";padding:18px 16px;" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, ";" + ( true ? "" : 0));
var Name = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e3dd55v1"
} : 0)(function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.textBoldSmall.css;
}, ";width:100%;text-align:left;transition:color 0.3s ease;" + ( true ? "" : 0));
var Avatar = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "e3dd55v0"
} : 0)( true ? {
  name: "qzff0m",
  styles: "border-radius:50%;max-width:48px;max-height:48px;object-fit:cover"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/AuthorCard/AuthorCard.tsx


var _excluded = ["children", "tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseAuthorCard = function BaseAuthorCard(_ref) {
  var externalAppearance = _ref.appearance,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      children = _ref.children,
      tokens = _ref.tokens;
  var appearance = (0,AppearanceContext/* useAppearance */.M)(externalAppearance);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, _objectSpread(_objectSpread({}, tokens), {}, {
    variant: variant,
    appearance: appearance,
    children: children
  }));
};

var BaseDescription = function BaseDescription(_ref2) {
  var children = _ref2.children,
      tokens = _ref2.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, _objectSpread(_objectSpread({
    tokens: tokens,
    variant: "textTiny"
  }, rest), {}, {
    children: children
  }));
};

var AuthorCard_Description = (0,withDesignTokens/* default */.Z)(BaseDescription, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[400]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[400]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[50]
    };
  }
});
var Body = function Body(_ref3) {
  var children = _ref3.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BodyWrapper, {
    children: children
  });
};
var AuthorCard = (0,withDesignTokens/* default */.Z)(BaseAuthorCard, function (_ref4) {
  var variant = _ref4.variant;
  return {
    variant: variant
  };
}, {
  light: function light(theme, _ref5) {
    var variant = _ref5.variant;

    if (variant === "filled") {
      return {
        backgroundColor: theme.palette.neutrals.white[100],
        color: theme.palette.brand.boysenberry[400]
      };
    }

    return {
      backgroundColor: "transparent",
      color: theme.palette.brand.boysenberry[400]
    };
  },
  dark: function dark(theme, _ref6) {
    var variant = _ref6.variant;

    if (variant === "filled") {
      return {
        backgroundColor: theme.palette.neutrals.cloud[100],
        color: theme.palette.brand.boysenberry[400]
      };
    }

    return {
      backgroundColor: "transparent",
      color: theme.palette.brand.boysenberry[300]
    };
  },
  twilioLight: function twilioLight(theme, _ref7) {
    var variant = _ref7.variant;

    if (variant === "filled") {
      return {
        backgroundColor: theme.palette.neutrals.white[100],
        color: theme.palette.twilio.gray[100]
      };
    }

    return {
      backgroundColor: "transparent",
      color: theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var AuthorCard_AuthorCard = ((/* unused pure expression or super */ null && (AuthorCard)));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/AuthorCard/index.ts


AuthorCard.displayName = "AuthorCardBase";
Avatar.displayName = "AuthorCard.Avatar";
Body.displayName = "AuthorCard.Body";
Name.displayName = "AuthorCard.Name";
AuthorCard_Description.displayName = "AuthorCard.Description";

// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/components/VideoPlayer/index.ts + 2 modules
var VideoPlayer = __webpack_require__(41926);
// EXTERNAL MODULE: ../../libs/matcha/components/Elevation/index.ts + 2 modules
var Elevation = __webpack_require__(33606);
;// CONCATENATED MODULE: ./src/views/GrowthMasters/LessonPage/Hero/Video.tsx


function Video_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var Video = function Video(_ref) {
  var url = _ref.url,
      cover = _ref.cover;

  var _useState = (0,react.useState)(false),
      playing = _useState[0],
      setPlaying = _useState[1];

  var play = function play() {
    return setPlaying(true);
  };

  var stop = function stop() {
    return setPlaying(false);
  };

  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Elevation/* default */.Z, {
    elevation: 1,
    type: "dropShadow",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(VideoPlayer/* default */.ZP, {
      url: url,
      playing: playing,
      onPause: stop,
      onPlay: play,
      config: {
        wistia: {
          options: {
            playerColor: theme.palette.twilio.gray[100],
            playButton: false,
            smallPlayButton: false
          }
        }
      },
      children: [!playing && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VideoPlayer/* BigPlayButton */.sT, {
        ariaLabel: "Play Button",
        onClick: play
      }), !playing && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VideoPlayer/* Cover */.Y9, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Picture, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
            type: "image/webp",
            srcSet: cover
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledImage, {
            width: "800",
            height: "455",
            src: cover,
            alt: "Illustration: Cover",
            loading: "lazy"
          })]
        })
      }, "cover")]
    })
  });
};

var Picture = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("picture",  true ? {
  target: "e1d8lq1d1"
} : 0)( true ? {
  name: "9th5i",
  styles: "margin:0 auto"
} : 0);

var StyledImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "e1d8lq1d0"
} : 0)("background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.gray[100];
}, ";display:block;width:100%;height:100%;object-fit:cover;" + ( true ? "" : 0));

/* harmony default export */ var Hero_Video = (Video);
// EXTERNAL MODULE: ../../node_modules/react-share/es/LinkedinShareButton.js
var LinkedinShareButton = __webpack_require__(36985);
// EXTERNAL MODULE: ../../node_modules/react-share/es/TwitterShareButton.js
var TwitterShareButton = __webpack_require__(8347);
// EXTERNAL MODULE: ../../node_modules/react-share/es/FacebookShareButton.js
var FacebookShareButton = __webpack_require__(80314);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/SocialMedia.ts + 4 modules
var SocialMedia = __webpack_require__(49911);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
;// CONCATENATED MODULE: ./src/views/GrowthMasters/LessonPage/Hero/ShareLesson.tsx


function ShareLesson_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var copy = {
  title: "Share this lesson"
};

var ShareLesson = function ShareLesson(_ref) {
  var slug = _ref.slug;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var shareUrl = (0,getAbsoluteUrl/* default */.Z)("/growth-masters/".concat(slug, "/"), pageConfig);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ShareLesson_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTypography, {
      tag: "p",
      variant: "h5",
      children: copy.title
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LinksWrapper, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkedinShareButton/* default */.Z, {
          url: shareUrl,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialMedia/* LinkedinIcon */.pA, {
            size: "nav"
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TwitterShareButton/* default */.Z, {
          url: shareUrl,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialMedia/* TwitterIcon */.Zm, {
            size: "nav"
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FacebookShareButton/* default */.Z, {
          url: shareUrl,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialMedia/* FacebookIcon */.Vq, {
            size: "nav"
          })
        })
      })]
    })]
  });
};

var ShareLesson_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e9p6yff3"
} : 0)( true ? {
  name: "n09foy",
  styles: "display:grid;justify-content:start;padding:24px 0"
} : 0);

var StyledTypography = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e9p6yff2"
} : 0)( true ? {
  name: "1ee42c1",
  styles: "margin:12px 0"
} : 0);

var IconWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e9p6yff1"
} : 0)( true ? {
  name: "1p8xof1",
  styles: "display:flex;flex-direction:row;justify-content:center;align-items:center;padding:10px;gap:10px"
} : 0);

var LinksWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e9p6yff0"
} : 0)( true ? {
  name: "185oq5j",
  styles: "display:flex;flex-direction:row;align-items:flex-start;padding:0px;gap:8px"
} : 0);

/* harmony default export */ var Hero_ShareLesson = (ShareLesson);
;// CONCATENATED MODULE: ./src/views/GrowthMasters/LessonPage/Hero/Hero.tsx


function Hero_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var LessonPageHero = function LessonPageHero(_ref) {
  var slug = _ref.slug,
      title = _ref.title,
      description = _ref.description,
      badges = _ref.badges,
      speaker = _ref.speaker,
      videoUrl = _ref.videoUrl,
      videoThumbnail = _ref.videoThumbnail;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Hero_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Hero/* default */.ZP, {
      variant: "2Col",
      copyVariant: "narrow",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledHeroCopy, {
        children: [badges === null || badges === void 0 ? void 0 : badges.map(function (topic, key) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledBadge, {
            variant: "outlined",
            children: topic
          }, topic + key);
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h1",
          variant: "h2",
          children: title
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AuthorCard, {
          variant: "transparent",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Avatar, {
            alt: speaker.name,
            src: speaker.headshotUrl
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Body, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Name, {
              children: speaker.name
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AuthorCard_Description, {
              children: [speaker.title, " ", speaker.company]
            })]
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_ShareLesson, {
          slug: slug
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledHeroContents, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Video, {
          url: videoUrl,
          cover: videoThumbnail
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionBase, {
      variant: "centered",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
          centered: true,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "h2",
            variant: "pLarge",
            children: description
          })
        })
      })
    })]
  });
};

var Hero_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ewbkzd4"
} : 0)( true ? "" : 0);

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1ewbkzd3"
} : 0)(Section/* Wrapper */.im, "{padding-top:0;padding-bottom:0;gap:0;}" + ( true ? "" : 0));

var StyledBadge = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Badge/* default */.Z,  true ? {
  target: "e1ewbkzd2"
} : 0)( true ? {
  name: "pnbph2",
  styles: "margin-right:8px;margin-bottom:8px"
} : 0);

var StyledHeroCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Hero/* Copy */.CK,  true ? {
  target: "e1ewbkzd1"
} : 0)( true ? {
  name: "1j4wah5",
  styles: "align-self:flex-start;text-align:left"
} : 0);

var StyledHeroContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Hero/* Contents */.AU,  true ? {
  target: "e1ewbkzd0"
} : 0)( true ? {
  name: "1a45ute",
  styles: "max-width:640px;margin:0 auto"
} : 0);

/* harmony default export */ var Hero_Hero = (LessonPageHero);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ./src/views/GrowthMasters/components/Card/Card.tsx
var Card = __webpack_require__(79831);
;// CONCATENATED MODULE: ./src/views/GrowthMasters/LessonPage/RecommendedLessons/RecommendedLessons.tsx



function RecommendedLessons_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function RecommendedLessons_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? RecommendedLessons_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : RecommendedLessons_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function RecommendedLessons_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












var RecommendedLessons_copy = {
  heading: "Recommended lessons",
  buttonText: "Explore all sessions"
};

var RecommendedLessons = function RecommendedLessons(_ref) {
  var lessons = _ref.lessons;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    variant: "centered",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
        centered: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCopyTextHeading, {
          tag: "h3",
          variant: "h2",
          children: RecommendedLessons_copy.heading
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Contents */.AU, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
        overrides: {
          sm: 1,
          lg: 3
        },
        children: lessons.map(function (card, key) {
          return (0,emotion_react_browser_esm/* createElement */.az)(Card/* default */.Z, RecommendedLessons_objectSpread(RecommendedLessons_objectSpread({
            gated: false
          }, card), {}, {
            key: card.title + key
          }));
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
          href: (0,getAbsoluteUrl/* default */.Z)("/growth-masters/curriculum/", pageConfig),
          iconEnd: Common/* ChevronRightIcon */.XC,
          children: RecommendedLessons_copy.buttonText
        })
      })]
    })]
  });
};

var StyledCopyTextHeading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Heading */.X6,  true ? {
  target: "e13nna4y1"
} : 0)( true ? {
  name: "16oo1aq",
  styles: "max-width:684px;margin:0 auto"
} : 0);

var ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e13nna4y0"
} : 0)( true ? {
  name: "39w2o2",
  styles: "padding-top:56px;text-align:center"
} : 0);

/* harmony default export */ var RecommendedLessons_RecommendedLessons = (RecommendedLessons);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Card/index.ts + 31 modules
var recipes_Card = __webpack_require__(74881);
;// CONCATENATED MODULE: ./src/views/GrowthMasters/LessonPage/Resources/Resources.tsx


function Resources_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var Resources_copy = {
  heading: "Resources"
};

var Resources = function Resources(_ref2) {
  var resources = _ref2.resources;
  var shrinkColumn = resources.length < 3;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Resources_StyledSectionBase, {
    variant: "centered",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
        centered: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Resources_StyledCopyTextHeading, {
          tag: "h3",
          variant: "h2",
          children: Resources_copy.heading
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionContents, {
      shrinkColumn: shrinkColumn,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
        overrides: {
          sm: 1,
          lg: resources.length >= 3 ? 3 : resources.length
        },
        children: resources.map(function (card, key) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* default */.ZP, {
            href: card.url,
            "data-dynamic-link": "true",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Card/* Body */.uT, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Copy */.CK, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Headline */.s0, {
                  tag: "h3",
                  children: card.title
                })
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Action */.aU, {
                alignment: "right",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ChevronRightIcon */.XC, {})
              })]
            })
          }, card.title + key);
        })
      })
    })]
  });
};

var Resources_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "emzfxc02"
} : 0)(Section/* Wrapper */.im, "{padding-bottom:40px;}" + ( true ? "" : 0));

var Resources_StyledCopyTextHeading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Heading */.X6,  true ? {
  target: "emzfxc01"
} : 0)( true ? {
  name: "16oo1aq",
  styles: "max-width:684px;margin:0 auto"
} : 0);

var _ref =  true ? {
  name: "1i6tfnr",
  styles: "max-width:855px"
} : 0;

var StyledSectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "emzfxc00"
} : 0)(function (_ref3) {
  var shrinkColumn = _ref3.shrinkColumn;
  return shrinkColumn && _ref;
}, ";" + ( true ? "" : 0));

/* harmony default export */ var Resources_Resources = (Resources);
;// CONCATENATED MODULE: ./src/views/GrowthMasters/LessonPage/Lesson.tsx









var Lesson = function Lesson(_ref) {
  var slug = _ref.slug;

  var _useLessonQuery = (0,queries/* useLessonQuery */.Ct)({
    args: [slug]
  }),
      lesson = _useLessonQuery.data;

  if (!lesson) throw new Error("Lesson is missing. Make sure it's preloaded");
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Layout/* default */.Z, {
    pageName: "Lesson",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {
      slug: slug,
      title: lesson.title,
      description: lesson.shortDescription,
      badges: lesson.badges,
      speaker: lesson.speaker,
      videoUrl: lesson.videoUrl,
      videoThumbnail: lesson.videoCoverUrl
    }), lesson.resources.length > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Resources_Resources, {
      resources: lesson.resources
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RecommendedLessons_RecommendedLessons, {
      lessons: lesson.recommended
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WantToLearnMore/* default */.Z, {})]
  });
};

/* harmony default export */ var LessonPage_Lesson = (Lesson);
// EXTERNAL MODULE: ./src/views/GrowthMasters/components/RedirectToHome/RedirectToHome.tsx
var RedirectToHome = __webpack_require__(90696);
// EXTERNAL MODULE: ./src/views/GrowthMasters/hooks/useInitialCookie.tsx
var useInitialCookie = __webpack_require__(86052);
// EXTERNAL MODULE: ./src/contexts/gatedContent.ts
var gatedContent = __webpack_require__(62906);
// EXTERNAL MODULE: ../../libs/contexts/staticSiteBackend.ts
var contexts_staticSiteBackend = __webpack_require__(86708);
;// CONCATENATED MODULE: ./src/pages/growth-masters/[slug].tsx









var GrowthMastersLessonPage = function GrowthMastersLessonPage(_ref) {
  var slug = _ref.slug;
  var staticSiteBackend = (0,react.useMemo)(function () {
    return (0,contexts_staticSiteBackend/* createStaticSiteBackend */.I4)();
  }, []);

  var _useInitialCookie = (0,useInitialCookie/* default */.Z)(),
      _useInitialCookie2 = (0,slicedToArray/* default */.Z)(_useInitialCookie, 3),
      showContent = _useInitialCookie2[0],
      isLoading = _useInitialCookie2[1],
      updateRegistered = _useInitialCookie2[2];

  return showContent ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(contexts_staticSiteBackend/* StaticSiteBackendProvider */.D1, {
    value: staticSiteBackend,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(gatedContent/* GatedContentProvider */.$8, {
      value: {
        showContent: showContent,
        updateRegistered: updateRegistered
      },
      children: isLoading ? null : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LessonPage_Lesson, {
        slug: slug
      })
    })
  }) : isLoading ? null : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RedirectToHome/* default */.Z, {});
};

var __N_SSG = true;
/* harmony default export */ var _slug_ = (GrowthMastersLessonPage);

/***/ }),

/***/ 90696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);



var RedirectToHome = function RedirectToHome() {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    router.push("/growth-masters/");
  }, [router]);
  return null;
};

/* harmony default export */ __webpack_exports__["Z"] = (RedirectToHome);

/***/ }),

/***/ 39896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ createClient; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
;// CONCATENATED MODULE: ../../libs/utils/retry/retry.ts



var wait = function wait(waitTime) {
  return new Promise(function (resolve) {
    setTimeout(resolve, waitTime);
  });
};

var numberSuffixes = ["st", "nd", "rd"];

var functionFailedText = function functionFailedText(iteration) {
  var _numberSuffixes$itera;

  return "Function failed. Retrying ".concat(iteration + 1).concat((_numberSuffixes$itera = numberSuffixes[iteration]) !== null && _numberSuffixes$itera !== void 0 ? _numberSuffixes$itera : "th", " time...");
};

var allRetriesFailedText = function allRetriesFailedText(retriesCount, errors) {
  return "Function failed too many times. Tired ".concat(retriesCount, " time").concat(retriesCount > 1 ? "s" : "", ".\nThrown errors:\n").concat(errors.map(function (e) {
    return e.toString();
  }).join("\n\n"), "\n");
};
/* eslint-disable no-await-in-loop */

/**
 * Retry function call
 * @param fn - The function to be called
 * @param options - The options object
 * @param options.times - Total amount of function calls. First function call is included.
 * @param options.waitTime - Wait time between retries in milliseconds
 * @returns The function with retries
 */


var retry = function retry(fn, _ref) {
  var times = _ref.times,
      waitTime = _ref.waitTime;
  return /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var errors,
        i,
        _args = arguments;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            errors = [];
            i = 0;

          case 2:
            if (!(i < times)) {
              _context.next = 19;
              break;
            }

            _context.prev = 3;
            _context.next = 6;
            return fn.apply(void 0, _args);

          case 6:
            return _context.abrupt("return", _context.sent);

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](3);
            console.log(functionFailedText(i));

            if (!(i + 1 < times)) {
              _context.next = 15;
              break;
            }

            _context.next = 15;
            return wait(waitTime);

          case 15:
            errors.push(_context.t0);

          case 16:
            i++;
            _context.next = 2;
            break;

          case 19:
            throw new Error(allRetriesFailedText(times, errors));

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 9]]);
  }));
};
/* eslint-enable no-await-in-loop */


/* harmony default export */ var retry_retry = (retry);
;// CONCATENATED MODULE: ../../libs/utils/retry/index.ts

;// CONCATENATED MODULE: ../../libs/api/staticSiteBackend/client.ts
/* provided dependency */ var process = __webpack_require__(34406);



var OMIT_CACHE_PARAMETER = "omitCache";
var CONTENT_PREVIEW_PARAMETER = "contentPreview";

var isCacheDisabled = function isCacheDisabled() {
  return process.env.CI;
};

var createClient = function createClient() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$retry = _ref.retry,
      retryOptions = _ref$retry === void 0 ? {
    times: 3,
    waitTime: 1000
  } : _ref$retry;

  function get(_x, _x2) {
    return _get.apply(this, arguments);
  }

  function _get() {
    _get = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(url, options) {
      var fullUserUrl, fullUrl, isOmitCacheParamMissing, startTime, response, json, endTime, requestTime;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!url.startsWith("/")) {
                _context.next = 20;
                break;
              }

              fullUserUrl = "".concat("https://segment.com/backend").concat(url);
              fullUrl = new URL(fullUserUrl);
              isOmitCacheParamMissing = !fullUrl.searchParams.has(OMIT_CACHE_PARAMETER);

              if (isOmitCacheParamMissing && isCacheDisabled()) {
                fullUrl.searchParams.append(OMIT_CACHE_PARAMETER, "");
              }

              if (process.env.IS_CONTENTFUL_PREVIEW_BRANCH === "true") {
                fullUrl.searchParams.append(CONTENT_PREVIEW_PARAMETER, "true");
              }

              startTime = Date.now();
              _context.next = 9;
              return fetch(fullUrl.toString(), options);

            case 9:
              response = _context.sent;

              if (!response.ok) {
                _context.next = 17;
                break;
              }

              _context.next = 13;
              return response.json();

            case 13:
              json = _context.sent;

              if (!(options !== null && options !== void 0 && options.responseHeaders)) {
                _context.next = 16;
                break;
              }

              return _context.abrupt("return", {
                data: json,
                headers: response.headers
              });

            case 16:
              return _context.abrupt("return", json);

            case 17:
              endTime = Date.now();
              requestTime = (endTime - startTime) / 1000;
              throw new Error("HTTP error ".concat(response.status, ": ").concat(response.statusText, "\nwhile trying to fetch: ").concat(fullUrl, "\nresponse returned after: ").concat(requestTime, " seconds\n      "));

            case 20:
              throw new Error("Client supports only absolute paths (starting with /)");

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _get.apply(this, arguments);
  }

  var retryGet = retry_retry(get, retryOptions);
  return {
    get: retryGet
  };
};



/***/ }),

/***/ 49911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Vq": function() { return /* reexport */ SocialMedia_FacebookIcon; },
  "ET": function() { return /* reexport */ SocialMedia_GithubIcon; },
  "pA": function() { return /* reexport */ SocialMedia_LinkedinIcon; },
  "Zm": function() { return /* reexport */ SocialMedia_TwitterIcon; }
});

// EXTERNAL MODULE: ../../libs/matcha/components/Icons/utils/createIconsComponent.tsx + 1 modules
var createIconsComponent = __webpack_require__(37699);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/SocialMedia/FacebookIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */


var FacebookIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M12.4468 19.9792C12.45 19.9497 12.4516 19.9196 12.4516 19.8893V12.6865H14.9133C15.308 12.6865 15.6633 12.4265 15.721 12.036C15.8164 11.39 15.7759 10.8026 15.7141 10.3849C15.6575 10.0014 15.3158 9.74892 14.9282 9.74892H12.4516C12.4516 7.52919 12.8209 7.2062 14.9026 7.1658C15.302 7.15806 15.6606 6.89428 15.7186 6.49892C15.816 5.83436 15.7772 5.25373 15.716 4.84525C15.6596 4.46794 15.3213 4.22199 14.9399 4.22532C11.2606 4.25742 9.16502 4.69252 9.16502 9.74892H7.25889C6.88845 9.74892 6.55956 9.98114 6.50351 10.3474C6.44316 10.742 6.40667 11.3139 6.50742 12.0096C6.56564 12.4115 6.92707 12.6865 7.33311 12.6865H9.16502V20.0008C6.31613 19.9821 4.27698 19.8696 2.9492 19.7617C1.48793 19.643 0.360453 18.5153 0.241729 17.0538C0.123591 15.5995 0 13.2919 0 10.0018C0 6.71167 0.123591 4.40402 0.241729 2.94972C0.360453 1.48819 1.48793 0.360517 2.9492 0.241772C4.40324 0.123608 6.71049 0 10 0C13.2895 0 15.5968 0.123613 17.0508 0.241772C18.512 0.360517 19.6396 1.4882 19.7583 2.94972C19.8764 4.40402 20 6.71167 20 10.0018C20 13.2919 19.8764 15.5995 19.7583 17.0538C19.6396 18.5154 18.512 19.643 17.0508 19.7617C15.9884 19.8481 14.4705 19.9373 12.4468 19.9792Z",
    fill: "none"
  })
}), 'FacebookIcon', 'SocialMedia');
/* harmony default export */ var SocialMedia_FacebookIcon = (FacebookIcon);
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/SocialMedia/GithubIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */


var GithubIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.073C0 3.483 3.423 0 7.897 0C12.371 0 16 3.484 16 8.073C16 11.742 13.813 14.882 10.587 15.98C10.177 16.056 10.029 15.795 10.029 15.58L10.031 14.997C10.034 14.426 10.039 13.56 10.039 12.814C10.039 12.036 9.787 11.54 9.49 11.279C11.293 11.07 13.194 10.815 13.194 7.623C13.194 6.716 12.877 6.26 12.361 5.674C12.445 5.459 12.719 4.576 12.277 3.428C11.603 3.209 10.052 4.321 10.052 4.321C9.39292 4.13403 8.71108 4.03946 8.026 4.04C7.339 4.04 6.646 4.136 6 4.32C6 4.32 4.448 3.213 3.774 3.428C3.332 4.572 3.606 5.459 3.69 5.674C3.174 6.256 2.929 6.713 2.929 7.623C2.929 10.806 4.749 11.073 6.552 11.279C6.319 11.497 6.11 11.864 6.035 12.393C5.575 12.612 4.39 12.979 3.684 11.703C3.242 10.915 2.439 10.849 2.439 10.849C1.649 10.839 2.387 11.358 2.387 11.358C2.917 11.606 3.284 12.568 3.284 12.568C3.758 14.051 6.016 13.555 6.016 13.555C6.0168 14.232 6.02013 14.909 6.026 15.586C6.026 15.801 5.881 16.063 5.468 15.986C2.252 14.883 0 11.742 0 8.073ZM4.487 12.896C4.39 12.876 4.326 12.8 4.348 12.734C4.371 12.668 4.464 12.634 4.548 12.658C4.645 12.688 4.706 12.764 4.688 12.83C4.668 12.896 4.571 12.93 4.488 12.896H4.487ZM5.184 13.002C5.277 13.002 5.352 12.949 5.352 12.882C5.352 12.807 5.268 12.754 5.171 12.764C5.077 12.764 5.003 12.817 5.003 12.883C5.003 12.959 5.077 13.012 5.183 13.002H5.184ZM5.774 12.678C5.681 12.701 5.616 12.764 5.626 12.84C5.636 12.906 5.72 12.95 5.816 12.926C5.91 12.903 5.974 12.84 5.965 12.774C5.955 12.711 5.868 12.668 5.775 12.678H5.774ZM3.135 11.41C3.094 11.444 3.103 11.52 3.158 11.582C3.21 11.635 3.284 11.658 3.326 11.616C3.368 11.582 3.358 11.506 3.303 11.443C3.252 11.39 3.177 11.367 3.135 11.41ZM2.861 11.27C2.797 11.238 2.764 11.185 2.787 11.142C2.81 11.109 2.861 11.099 2.926 11.119C2.99 11.152 3.023 11.205 3 11.248C2.977 11.294 2.913 11.304 2.861 11.271V11.27ZM3.832 12.32C3.781 12.362 3.8 12.462 3.874 12.524C3.948 12.6 4.042 12.61 4.084 12.558C4.126 12.515 4.106 12.415 4.042 12.352C3.971 12.276 3.874 12.266 3.832 12.319V12.32ZM3.465 12.028C3.413 11.952 3.413 11.866 3.465 11.833C3.516 11.79 3.6 11.823 3.645 11.899C3.697 11.975 3.697 12.061 3.645 12.104C3.603 12.137 3.516 12.104 3.465 12.028Z",
    fill: "none"
  })
}), 'GithubIcon', 'SocialMedia');
/* harmony default export */ var SocialMedia_GithubIcon = (GithubIcon);
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/SocialMedia/LinkedinIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */


var LinkedinIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.14 0H14.857C15.1615 0.00185152 15.4528 0.124378 15.6671 0.340709C15.8813 0.557041 16.0011 0.849518 16 1.154V14.846C16.0011 15.1505 15.8813 15.443 15.6671 15.6593C15.4528 15.8756 15.1615 15.9981 14.857 16H1.14C0.511 16 0 15.482 0 14.846V1.154C0 0.518 0.51 0 1.14 0ZM2.464 13.714H4.84V6.08H2.464V13.715V13.714ZM3.65 5.035C3.2944 5.02144 2.95789 4.87063 2.7111 4.61425C2.46431 4.35788 2.32645 4.01586 2.32645 3.66C2.32645 3.30414 2.46431 2.96212 2.7111 2.70574C2.95789 2.44937 3.2944 2.29856 3.65 2.285C4.407 2.285 5.025 2.903 5.025 3.66C5.025 4.42 4.411 5.035 3.65 5.035ZM11.354 13.714H13.725V9.528C13.725 7.471 13.278 5.888 10.879 5.888C9.725 5.888 8.949 6.521 8.632 7.121H8.6V6.078H6.325V13.714H8.696V9.935C8.696 8.939 8.886 7.975 10.121 7.975C11.336 7.975 11.353 9.114 11.353 9.999V13.714H11.354Z",
    fill: "none"
  })
}), 'LinkedinIcon', 'SocialMedia');
/* harmony default export */ var SocialMedia_LinkedinIcon = (LinkedinIcon);
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/SocialMedia/TwitterIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */


var TwitterIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M14.355 4.74001C14.365 4.88201 14.365 5.02401 14.365 5.16601C14.365 9.50301 11.066 14.5 5.035 14.5C3.2498 14.5044 1.50135 13.9929 0 13.027C0.264 13.057 0.518 13.068 0.792 13.068C2.26801 13.0715 3.70216 12.5776 4.863 11.666C4.17863 11.6535 3.51526 11.4275 2.96557 11.0196C2.41589 10.6118 2.00734 10.0424 1.797 9.39101C2 9.42101 2.203 9.44201 2.417 9.44201C2.711 9.44201 3.005 9.40201 3.279 9.33001C2.53627 9.1796 1.86854 8.77666 1.38927 8.18966C0.910009 7.60265 0.648787 6.86781 0.65 6.11001V6.07001C1.087 6.31401 1.595 6.46601 2.133 6.48701C1.68273 6.18762 1.31352 5.78149 1.05826 5.30482C0.802995 4.82814 0.669615 4.29573 0.67 3.75501C0.67 3.14501 0.832 2.58701 1.117 2.09901C1.94043 3.11309 2.96784 3.94275 4.13259 4.53417C5.29734 5.12558 6.5734 5.46555 7.878 5.53201C7.82542 5.28476 7.79828 5.03278 7.797 4.78001C7.79674 4.3492 7.8814 3.92256 8.04614 3.52449C8.21088 3.12643 8.45247 2.76474 8.7571 2.46011C9.06173 2.15548 9.42342 1.91389 9.82149 1.74915C10.2196 1.5844 10.6462 1.49974 11.077 1.50001C11.5259 1.49904 11.9703 1.59052 12.3823 1.76876C12.7944 1.94699 13.1653 2.20817 13.472 2.53601C14.2063 2.39454 14.9104 2.12656 15.553 1.74401C15.3088 2.50199 14.7964 3.14485 14.112 3.55201C14.772 3.48101 15.412 3.29801 16 3.04401C15.551 3.69785 14.9948 4.27124 14.355 4.74001Z",
    fill: "none"
  })
}), 'TwitterIcon', 'SocialMedia');
/* harmony default export */ var SocialMedia_TwitterIcon = (TwitterIcon);
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/SocialMedia.ts
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */





/***/ }),

/***/ 60757:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/growth-masters/[slug]",
      function () {
        return __webpack_require__(6685);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,8943,8530,463,1382,4136,8392,2073,7096,2429,3996,4881,9524,3500,9833,9272,5250,9774,2888,179], function() { return __webpack_exec__(60757); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);